module.exports = __webpack_public_path__ + "a8efd89e395068d9bfd116f37b40dba2.mp3"


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/OAM_3.mp3
 ** module id = 174
 ** module chunks = 0
 **/